import axios from "axios";

export default {
	namespaced: true,
	state: {
		network: null,
	},
	mutations: {
		setNetwork(state, payload) {
			state.network = payload;
		},
	},
	getters: {
		getNetwork(state) {
			return state.network;
		},
	},
	actions: {
		async getSelfNetwork(ctx) {
			return axios
				.get(`/api/v1/account/connection/me`, {
					headers: {
						// "X-Forwarded-For": "24.114.0.1", //CA
						// "X-Forwarded-For": "8.8.8.8", //US
						// "X-Forwarded-For": "1.120.0.1", //AU
					},
				})
				.then((res) => {
					if (res.status === 200) {
						ctx.commit("setNetwork", res.data);
					} else {
						ctx.commit("setNetwork", null);
					}
					return res;
				})
				.catch((err) => {
					console.log("Fail to query getSelfNetwork", err);
					return err;
				});
		},
	},
};
